import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="w-full bg-[#0A0A0A] py-16 px-4 border-t border-[#16161F] pt-[20px] pb-[20px]" data-id="element-253">
      <div className="max-w-2xl mx-auto" data-id="element-254">
        <div className="bg-[#16161F] border border-[#FF6B00] rounded-3xl p-8 sm:p-10 text-center shadow-2xl relative overflow-hidden" data-id="element-255">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#FF6B00] to-[#FFD700]" data-id="element-256" />

          <p className="text-[#FF6B00] text-xs sm:text-sm font-black uppercase tracking-widest mb-4" data-id="element-257">
            ⏰ Zeitlich begrenztes Angebot
          </p>

          <h2 className="text-2xl sm:text-4xl font-black text-white mb-8 tracking-tight" data-id="element-258">
            Der Einführungspreis endet in:
          </h2>

          <div className="mb-8" data-id="element-259">
            <CountdownTimer size="lg" blinking={true} data-id="element-260" />
          </div>

          <p className="text-white text-base sm:text-lg font-bold mb-8" data-id="element-261">
            Danach steigt der Preis wieder auf den regulären Wert.
          </p>

          <div className="max-w-sm mx-auto" data-id="element-262">
            <div className="w-full bg-[#0A0A0A] rounded-full h-4 overflow-hidden border border-[#FF6B0033] mb-3" data-id="element-263">
              <div className="h-full rounded-full bg-gradient-to-r from-[#FF6B00] to-[#FFD700]" style={{
              width: '72%'
            }} data-id="element-264" />
            </div>
            <div className="flex items-center justify-between px-1" data-id="element-265">
              <span className="text-[#FF6B00] font-black text-xs uppercase tracking-wider" data-id="element-266">
                🔴 Limitierte Plätze
              </span>
              <span className="text-[#B0B0C0] font-bold text-xs uppercase tracking-wider" data-id="element-267">
                72% vergeben
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}